import React from "react"
import { styled } from "@mui/material/styles"
import Select from "react-select"

const UserSelectFilterContainer = styled("div")`
  position: absolute;
  max-width: 10%;
  z-index: 300;
`
export default class UserSelectFilter extends React.Component {
  constructor(props) {
    super(props)
  }

  customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: 300,
      margin: "3px",
      fontSize: "12px",
      fontWeight: 300,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0.5px 0 0.5px 8px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "15px",
      fontWeight: 300,
    }),
  }

  render() {
    const {
      handleSelectChange,
      userSlugsToExcludeOptions,
      allSampleUploaders,
      filterName,
      ariaLabel,
    } = this.props

    const options = allSampleUploaders.map((user) => ({
      value: user.slug,
      label: user.display_name,
      key: user.slug,
      key: user.slug,
    }))

    return (
      <UserSelectFilterContainer>
        <Select
          styles={this.customStyles}
          isMulti
          value={userSlugsToExcludeOptions}
          onChange={handleSelectChange}
          options={options}
          closeMenuOnSelect={false}
          placeholder="Select Users"
          name={filterName}
          aria-label={ariaLabel}
          role="combobox"
        />
      </UserSelectFilterContainer>
    )
  }
}
